invHdApp.
factory('Billing', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/bills', data);
      },
      get: function(id) {
        return $http.get('api/bill/' + id);
      },
      new: function(id) {
        return $http.get('api/new-bill');
      },
      delete: function(id) {
        return $http.delete('api/delete-bill/' + id);
      },
      save: function(data) {
        return $http.post('api/save-bill',data);
      },
      update: function(data) {
        return $http.post('api/update-bill',data);
      },
      addPayment: function(data) {
        return $http.post('api/save-bill-payment',data);
      },
      updatePayment: function(data) {
        return $http.post('api/update-bill-payment',data);
      },
      deletePayment: function(id) {
        return $http.delete('api/delete-bill-payment/' + id);
      },
    };
}]);